import { BOOKS_URL, ACTIVITIES_DATA_PATH } from '../../data/environment';
import FetchHandler from '../fetch_handler';

export default function getPostReadingData(bookId) {
  return FetchHandler
    .init(`${BOOKS_URL}/${bookId}/${ACTIVITIES_DATA_PATH}/post-reading.json`)
    .catch(() => []);
}
